import React from 'react';
import SkeletonValuePlaceholder from './SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import { twMerge } from 'tailwind-merge';

const MarketDetailStat = ({
	label,
	value,
	onClick,
	prefix,
	suffix,
	className,
	end,
}: {
	label: string;
	value: string;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
	prefix?: string;
	suffix?: string;
	className?: string;
	end?: boolean;
}) => {
	return value ? (
		<div
			onClick={onClick}
			className={twMerge(
				`px-2 rounded-md font-display hover:bg-container-bg-selected`,
				className
			)}
		>
			<div>
				<div className={`flex flex-col ${end ? 'items-end' : 'items-start'}`}>
					<div
						className={`overflow-hidden text-text-label text-xs daily-volume-label`}
					>
						{label}
					</div>
					<div className="space-x-2 text-center text-text-default">
						<div className="text-sm text-center">
							<div className={`overflow-hidden font-numeral`}>
								{prefix ?? ''}
								{value}
								{suffix ?? ''}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	) : (
		<SkeletonValuePlaceholder className="w-16 h-[18px]" loading={true} />
	);
};

export default MarketDetailStat;
